import { COMPANY_PROFILE_ITEMS_MAPPER } from 'components/landing/constants';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import styles from 'styles/LandingCompanyProfile.module.scss';
import { useTranslations } from 'next-intl';

const CompanyProfileIconsMapper = dynamic(() => import('components/icons/landing/company-information-icons/mapper'));

const CompanyInformationTable = ({ colorSchema, data }) => {
    const t = useTranslations('table.company-profile');

    if (!data) {
        return null;
    }

    return (
        <div className={styles.container}>
            {COMPANY_PROFILE_ITEMS_MAPPER.map((item, index) => {
                const value = data[item];
                if (!value) {
                    return null;
                }
                return (
                    <div className={styles.item} key={index}>
                        <CompanyProfileIconsMapper input={item} color={colorSchema} size={50} />
                        <p
                            className={styles.label}
                            style={{ color: colorSchema }}
                        >
                            {t(item)}
                        </p>
                        <p className={styles.caption}>{value}</p>
                    </div>
                );
            })}
        </div>
    );
};

CompanyInformationTable.propTypes = {
    data: PropTypes.object.isRequired,
    colorSchema: PropTypes.string.isRequired
};

export default CompanyInformationTable;
